<script>
import 'vue-select/dist/vue-select.css'
import { axiosGetPost } from '@router/axiosGetPost'

export default {
  name: 'HideColumnsTable',
  props: {
    fieldListFth: {type: [Object, Array], default: null},
    typeTable: {type: [String], default: null},
  },
  data() {
    return {
      fields: [],
      excludeFields: [],
      fieldList: [],
    }
  },
  computed: {},
  created() {
    this.fieldList = this.fieldListFth
    this.updateTableFields('SELECT')
  },
  mounted() {},
  methods: {
    updateTableFields(action = 'SELECT') {
      if (action === 'SELECT') {
        axiosGetPost('post', 'settingU/', {
          modules: [this.typeTable],
        }).then((data) => {
          if (data.success === true) {
            this.excludeFields = data.data[this.typeTable]
            this.orderFields()
          } else {
            this.$toastr.e('Error Load Exclude column Select' + data.error)
          }
          return data
        })
      } else if (action === 'UPDATE') {
        this.orderFields()
        axiosGetPost('put', 'settingU/', {
          modules: [{ name: this.typeTable, data: this.excludeFields }],
        }).then((data) => {
          if (data.success !== true) {
            this.$toastr.e('Error Load Exclude column Update' + data.error)
          }
          return data
        })
      }
    },
    orderFields() {
      this.fields = []
      for (var [key, value] of Object.entries(this.fieldList)) {
        if (!(this.excludeFields.indexOf(value.key) > -1)) {
          this.fields.push(this.fieldList[key])
        }
      }
      this.$emit('updateTableFieldsEmit', this.fields)
    },
  },
}
</script>

<template>
  <div>
    <b-dropdown
      class="d-inline"
      variant="link"
      toggle-class="font-weight-bold p-0 align-middle"
    >
      <template v-slot:button-content>
        Hide Columns
        <i class="uil uil-eye-slash font-size-16 align-middle"></i
        ><i class="uil uil-angle-down font-size-16 align-middle"></i>
      </template>
      <div v-for="(field, index) of fieldList" :key="index">
        <div v-if="field.checkBox" class="dropdown-item">
          <div class="col-lg-6 mb-2 mb-lg-0">
            <div :for="`field-${index}`" class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                :id="`field-${index}`"
                :value="field.key"
                v-model="excludeFields"
                @change="updateTableFields('UPDATE')"
              />
              <label class="custom-control-label" :for="`field-${index}`">{{
                field.label
              }}</label>
            </div>
            <!-- end checkbox -->
          </div>
        </div>
      </div>
    </b-dropdown>
  </div>
</template>